export default "__VITE_ASSET__Cbm0T5YH__"